 import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import {finalize} from 'rxjs';

import {suppliersUnitsQuery, suppliersUnitsService} from '@store/suppliers/units';
import {supplierDetailsQuery} from '@store/suppliers/details';
import {GlobalStatus} from '@store/common/globalStatus.enum';

import {Add, Download, GroupAction} from '@icons/index';

import TabsComponent from '@components/tabs/Tabs.component';
import SupplierUnitsTable from '@screens/admin/suppliers/details/supplierUnits/SupplierUnits.table';

const SupplierUnitsTab = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {enqueueSnackbar} = useSnackbar();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(suppliersUnitsQuery.status$);
  const [selectedSupplierUnits] = useObservable(suppliersUnitsQuery.selectedSuppliersUnits$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    suppliersUnitsService.getSuppliersUnitsCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} mt="10px" spacing={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <TabsComponent
          ariaLabel="secondary"
          handleChange={(value) => suppliersUnitsService.setStatus(GlobalStatus.tabs[value])}
          value={GlobalStatus.tabs.indexOf(filterStatus ?? undefined)}
          tabs={[t('routes.all'), t('routes.archived')]}/>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined" color="primary"
            startIcon={<GroupAction/>}
            disabled={!selectedSupplierUnits.length}>
            {t('global.groupedAction')}
          </Button>
          <Button
            variant="outlined" color="primary"
            disabled={CSVLoading}
            onClick={handleExportCSV}
            startIcon={<Download/>}>
            {t('global.exportCSV')}
          </Button>
        </Stack>
      </Stack>
      <SupplierUnitsTable/>
    </Stack>
  );
};

export default SupplierUnitsTab;
